import { isMenuOpen } from '../../../jsCore/store/menu/menu.selectors'
import { connectWithStore } from '../../../jsCore/utils/connectWithStore'
import { MenuContainer } from './menu.container'
import { toggleMenu } from '../../../jsCore/store/menu/menu.actions'
import { getTopAdHeight } from '../../../jsCore/store/topAd/topAd.selectors'

const mapStateTpProps = state => ({
  isMenuOpen: isMenuOpen(state),
  topAdMargin: getTopAdHeight(state),
})
const mapDispatchToProps = {
  toggleMenu: toggleMenu,
}

export const MenuWithStoreComponent = connectWithStore(
  MenuContainer,
  mapStateTpProps,
  mapDispatchToProps
)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/menu/menuWithStore.container.js